import React, { FC } from 'react';
import { Collapse as MuiCollapse, Box, CollapseProps, BoxProps, Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

let Collapse: FC<CollapseProps & BoxProps> = MuiCollapse as any;

type ActionBarProps = {
  show?: boolean;
  children?: any;
};

const useStyles = makeStyles()((theme: Theme) => 
({
    root: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '64px',
      padding: theme.spacing(0, 1),
      backdropFilter: 'blur(5px)',
      zIndex: 1000,
    },
}))

const ActionBar: FC<ActionBarProps> = ({ children, show = true, ...props }) => {
  const { classes} = useStyles();

  return (
    <Collapse sx={{ position: 'sticky', bottom: 0, bgcolor: 'transparent', right: 0 }} in={show} component={Box} position="sticky">
      <div className={classes.root}>{children}</div>
    </Collapse>
  );
};

export default ActionBar;
